<template>
  <div class="find-data">
    <el-tabs
      v-model="activeName"
      :tab-position="screenWidth > 1023 ? 'left' : 'top'"
    >
      <el-tab-pane name="find_data">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            {{ $t('text.find_data') }}
          </div>
          <div class="label-desc">{{ $t('text.find_tagged_data') }}</div>
        </div>
        <div class="common-title-page">
          <div class="title-wrapper">
            <pods-input
              ref="podsInput"
              :globalSync="false"
              @updateData="getData()"
            ></pods-input>
            <span class="title">{{ $t('text.find_tagged_data') }}</span>
          </div>
          <div class="mb-20 mt-20">
            <span class="mr-10">{{ $t('text.find_data_with_tag') }}</span>
            <el-select
              class="mr-10"
              size="small"
              v-model="tagFilter"
              :placeholder="$t('text.please_select')"
              clearable
              multiple
            >
              <el-option
                v-for="item in tagOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <el-button
              class="cancel-btn mini-btn min-w-80 h-32"
              @click="getData()"
              >{{ $t('text.find') }}</el-button
            >
            <br class="show-mobile" />
            <div
              class="inline-block"
              :class="screenWidth > 767 ? 'right-float' : 'mt-10'"
            >
              <UtcOffsets />
            </div>
          </div>
          <div class="mb-20">
            <span>{{ $t('text.found') }}</span>
            <span class="right-float">
              <img src="../../assets/filter.svg" />
              <el-input
                v-model="filter"
                size="mini"
                class="search-input filter-input"
                :placeholder="$t('text.notes')"
              ></el-input>
            </span>
          </div>
          <el-table
            border
            ref="table"
            :data="tableData"
            size="small"
            v-loading="loading"
            :max-height="tableHeight"
          >
            <el-table-column :label="$t('text.mac_address')" prop="podMac">
            </el-table-column>
            <el-table-column
              :label="$t('text.tag_timestamp')"
              prop="tagDateTime"
            >
              <template slot-scope="scope">
                {{
                  moment
                    .utc(scope.row.tagDateTime)
                    .tz($store.state.pods.selectedUtcOffset)
                    .format('DD/MM/YY')
                }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('text.tagged_by')"
              prop="taggedBy"
            ></el-table-column>
            <el-table-column :label="$t('text.tag')" prop="tag">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.tag" :key="index">
                  {{ item }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('text.notes')"
              prop="notes"
            ></el-table-column>
            <el-table-column
              :label="$t('text.action') | firstLetterCapitalize"
              fixed="right"
              width="200px"
            >
              <template slot-scope="scope">
                <el-button
                  type="success"
                  plain
                  class="save-btn mini-btn min-w-80"
                  @click="edit(scope.row)"
                  >{{ $t('text.view') | firstLetterCapitalize }}</el-button
                >
                <el-button
                  type="success"
                  plain
                  class="delete-btn mini-btn min-w-80 ml-10"
                  @click="deleteRow(scope.row)"
                  >{{ $t('text.delete') | firstLetterCapitalize }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <ViewTaggedData ref="viewTaggedData" />
  </div>
</template>

<script>
import { tagOptions } from '../../const.js'
import PodsInput from '@/components/PodsInput'
import UtcOffsets from '@/components/UtcOffsets'
import ViewTaggedData from '@/components/pods/findData/ViewTaggedData'
import $ from 'jquery'
import CommonApiService from '@/services/CommonApiService.js'
import moment from 'moment'
import swal from 'sweetalert'
export default {
  data() {
    return {
      moment,
      activeName: 'find_data',
      screenWidth: window.innerWidth,
      loading: false,
      tableData: [],
      tagOptions: tagOptions,
      tagFilter: '',
      filter: '',
      timer: '',
      tableHeight: 0
    }
  },
  components: {
    PodsInput,
    UtcOffsets,
    ViewTaggedData
  },
  mounted: function() {
    window.addEventListener('resize', this.getScreenWidth)
    this.getScreenWidth()
    this.getData()
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 150
      let self = this
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 150
      }
    })
  },
  watch: {
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getData, 500)
    }
  },
  methods: {
    getScreenWidth() {
      this.screenWidth = window.innerWidth
      if (this.screenWidth < 1023) {
        $('.find-data .el-tabs__header').hide()
      } else {
        $('.find-data .el-tabs__header').show()
      }
    },
    getData() {
      this.loading = true
      CommonApiService.GetDataTags(
        this.$refs.podsInput.pod ? this.$refs.podsInput.pod.podId : '',
        JSON.parse(JSON.stringify(this.tagFilter)).join(','),
        this.filter
      )
        .then(response => {
          this.loading = false
          this.tableData = response.data.map(item => {
            return {
              ...item,
              tag: item.tag.split(',')
            }
          })
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    edit(row) {
      this.$refs.viewTaggedData.id = row.id
      this.$refs.viewTaggedData.openDialog()
    },
    deleteRow(row) {
      this.$confirm(
        'Please keep in mind that deleting tagged data is permanent',
        this.$t('text.you_able_to_delete_data') + ' this tag data',
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'delete-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: false,
          closeOnClickModal: false
        }
      )
        .then(() => {
          this.handleDelete(row)
        })
        .catch(() => {})
    },
    handleDelete(row) {
      CommonApiService.DeleteDataTagById(row.id)
        .then(() => {
          this.getData()
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
